import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export const BUSINESS = {
  name: "Akın Kombi & Tesisat",
  shortName: "Akın Kombi",
  tagline: "Diyarbakır Kombi & Tesisat Uzmanı",
  phone1: "0538 691 59 38",
  phone2: "0535 706 10 82",
  phone1Tel: "+905386915938",
  phone2Tel: "+905357061082",
  address:
    "Emre Yapı Kooperatifi, Peyas Mahallesi, Selahattin Eyyubi Blv. A Blok altı No: 27AB, 21070 Kayapınar/Diyarbakır",
  shortAddress: "Peyas Mh., Kayapınar / Diyarbakır",
  whatsapp: "+905386915938",
  mapQuery:
    "Emre Yapı Kooperatifi Peyas Mahallesi Selahattin Eyyubi Bulvarı Kayapınar Diyarbakır",
};

export const SERVICES = [
  {
    id: "kombi-tamirati",
    title: "Kombi Tamiratı",
    desc: "Tüm marka kombilerde arıza tespiti, tamir ve periyodik bakım hizmeti.",
    icon: "Wrench",
    image: "https://images.pexels.com/photos/7859953/pexels-photo-7859953.jpeg",
  },
  {
    id: "yedek-parca",
    title: "Kombi Yedek Parça",
    desc: "Orijinal ve garantili yedek parça temini. Sirkülasyon pompası, eşanjör, NTC, kart.",
    icon: "Cog",
    image: "https://images.pexels.com/photos/5463572/pexels-photo-5463572.jpeg",
  },
  {
    id: "dogalgaz",
    title: "Doğalgaz & Sıhhi Tesisat",
    desc: "Doğalgaz hattı çekimi, sıhhi tesisat montajı, kaçak tespiti ve tamir.",
    icon: "Flame",
    image: "https://images.unsplash.com/photo-1744688596038-57da319892f8",
  },
  {
    id: "hermetik-sofben",
    title: "Hermetik Şofben",
    desc: "Hermetik şofben kurulumu, bakım, baca montajı ve arıza giderme.",
    icon: "Droplets",
    image: "https://images.pexels.com/photos/5824883/pexels-photo-5824883.jpeg",
  },
  {
    id: "radyator-petek",
    title: "Radyatör Petek",
    desc: "Radyatör ve petek temizliği, hava alma, yeni petek montajı.",
    icon: "Thermometer",
    image: "https://images.pexels.com/photos/12034871/pexels-photo-12034871.jpeg",
  },
  {
    id: "elektrikli-kombi",
    title: "Elektrikli Kombi",
    desc: "Elektrikli kombi montajı, bakım ve arıza onarımı.",
    icon: "Zap",
    image: "https://images.pexels.com/photos/4792733/pexels-photo-4792733.jpeg",
  },
];
